import React from 'react';
import s from './s.module.less';

const Step1 = () => {
    return (
        <div className={s.wrap}>
            <h2>Build your profile to connect with more patients</h2>
            <p>Complete your profile so patients can easily find and book with you. With a Klarity profile, you can:</p>
            <div className={s.list}>
                <div className={s.item}>
                    <div className={s.itemInLeft}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M12.1 18.55L12 18.65L11.89 18.55C7.14 14.24 4 11.39 4 8.5C4 6.5 5.5 5 7.5 5C9.04 5 10.54 6 11.07 7.36H12.93C13.46 6 14.96 5 16.5 5C18.5 5 20 6.5 20 8.5C20 11.39 16.86 14.24 12.1 18.55ZM16.5 3C14.76 3 13.09 3.81 12 5.08C10.91 3.81 9.24 3 7.5 3C4.42 3 2 5.41 2 8.5C2 12.27 5.4 15.36 10.55 20.03L12 21.35L13.45 20.03C18.6 15.36 22 12.27 22 8.5C22 5.41 19.58 3 16.5 3Z" fill="#0E62F4" />
                        </svg>
                    </div>
                    <div className={s.itemInRight}>Showcase your specialties and offer care your way</div>
                </div>
                <div className={s.item}>
                    <div className={s.itemInLeft}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M17 20H22V18C22 16.3431 20.6569 15 19 15C18.0444 15 17.1931 15.4468 16.6438 16.1429M17 20H7M17 20V18C17 17.3438 16.8736 16.717 16.6438 16.1429M7 20H2V18C2 16.3431 3.34315 15 5 15C5.95561 15 6.80686 15.4468 7.35625 16.1429M7 20V18C7 17.3438 7.12642 16.717 7.35625 16.1429M7.35625 16.1429C8.0935 14.301 9.89482 13 12 13C14.1052 13 15.9065 14.301 16.6438 16.1429M15 7C15 8.65685 13.6569 10 12 10C10.3431 10 9 8.65685 9 7C9 5.34315 10.3431 4 12 4C13.6569 4 15 5.34315 15 7ZM21 10C21 11.1046 20.1046 12 19 12C17.8954 12 17 11.1046 17 10C17 8.89543 17.8954 8 19 8C20.1046 8 21 8.89543 21 10ZM7 10C7 11.1046 6.10457 12 5 12C3.89543 12 3 11.1046 3 10C3 8.89543 3.89543 8 5 8C6.10457 8 7 8.89543 7 10Z" stroke="#0E62F4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                    <div className={s.itemInRight}>Attract the right patients — whether they use insurance or pay cash</div>
                </div>
                <div className={s.item}>
                    <div className={s.itemInLeft}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M9 3.75H5.25V21.75H18.75V3.75H15M7.5 15.75H16.5M10.5 14.25V17.25M7.5 11.25H16.5M13.5 9.75V12.75M9 5.25L8.25 2.25H15.75L15 5.25H9Z" stroke="#0E62F4" strokeWidth="1.5" strokeLinejoin="round" />
                        </svg>
                    </div>
                    <div className={s.itemInRight}>Manage your patient engagement in one place — marketing, scheduling, messaging, and cash billing</div>
                </div>
            </div>
        </div>
    );
};

export default Step1;
